import { reactive } from "vue";
import { AdminFetcher } from "./adminFetcher";
import { VCSRouteName } from "../router";

export const superadminRules = reactive({
  prompts: false,
  ai_access: false,
  admins: false,
  external_users: false,
  reports: false,
});

export async function redirectAfterLogin(): Promise<VCSRouteName> {
  const check = await checkSuperAdmin();
  if (check) {
    if (superadminRules.reports) {
      return 'admin-statistics';
    } else if (superadminRules.prompts) {
      return 'admin-ai-settings'
    } else if (superadminRules.ai_access) {
      return 'admin-ai-access'
    } else if (superadminRules.admins) {
      return 'admin-accounts'
    } else if (superadminRules.external_users) {
      return 'admin-external-users'
    } else {
      return 'admin-no-access'
    }
  } else {
    return 'admin-login'
  }
}

export async function checkSuperAdmin() {
  try {
    const res = (await AdminFetcher.get({
      path: "/superadmin/check",
    })) as {
      message: string;
      main: boolean;
      prompts: boolean;
      ai_access: boolean;
      admins: boolean;
      external_users: boolean;
      reports: boolean;
    };
    superadminRules.prompts = res.prompts;
    superadminRules.ai_access = res.ai_access;
    superadminRules.admins = res.admins;
    superadminRules.external_users = res.external_users;
    superadminRules.reports = res.reports;
    return res.message === "ok";
  } catch (err: any) {
    if (err?.status === 401) {
      return false;
    }
    throw err;
  }
}

export async function apiLogin(login: string, password: string) {
  const res = (await AdminFetcher.post({
    path: "/superadmin/login",
    payload: {
      login,
      password,
    },
  })) as { message: string };
  return res.message;
}
